var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg375Vector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 7,
    viewBox: "0 0 10 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.260929 0.941544C0.608835 0.587194 1.1729 0.587194 1.52081 0.941544L5 4.48519L8.47919 0.941544C8.8271 0.587194 9.39116 0.587194 9.73907 0.941544C10.087 1.2959 10.087 1.87041 9.73907 2.22476L5.62994 6.41002C5.28203 6.76437 4.71797 6.76437 4.37006 6.41002L0.260929 2.22476C-0.0869765 1.87041 -0.0869765 1.2959 0.260929 0.941544Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg375Vector);
export default __webpack_public_path__ + "static/media/375_vector.066ae2e532599b0626e3e47cd484781d.svg";
export { ForwardRef as ReactComponent };